/* eslint-disable no-invalid-this */
/* eslint-disable func-names */
import * as yup from "yup";
import "data/yup-validation";

const requiredIfAddress1IsPresent = yup.string().requireSibling("address1");

const contactPhoneOrEmailReq = yup.string().test(
  "req-contact-phone-or-email",
  "A Phone number or Email is Required",
  function () {
    if (!this.parent.contactRelation) {
      return true;
    }
    return this.parent.contactPhone || this.parent.contactEmail;

  },
);

export const incomeStepSchema = yup.object().shape({
  isStayingOnList: yup.bool(),
  householdNetIncome: yup.string(),
  householdIncome: yup.string().required(),
  householdIncomeFrequency: yup.string().oneOf(["monthly", "yearly"]).required(),
  householdCount: yup.number().required(),
});

export const contactStepSchema = yup.object().shape({
  address1: yup.string(),
  address2: yup.string(),
  city: requiredIfAddress1IsPresent,
  state: requiredIfAddress1IsPresent,
  zip: requiredIfAddress1IsPresent,
  email: yup.string().email("Requires a valid email address"),
  primaryPhone: yup.string().validPhoneNumber(),
  secondaryPhone: yup.string().validPhoneNumber(),
  primaryPhoneType: yup.string().requireSibling("primaryPhone"),
  secondaryPhoneType: yup.string().requireSibling("secondaryPhone"),
  contactRelation: yup.string(),
  contactName: yup.string().requireSibling("contactRelation"),
  contactPhone: contactPhoneOrEmailReq.validPhoneNumber(),
  contactPhoneType: yup.string().requireSibling("contactPhone"),
  contactEmail: contactPhoneOrEmailReq.email("Requires a valid Email"),
  householdHasAuthorityVoucher: yup.boolean(),
});
